import _ from 'lodash';

export default {
    toString: function toString(code) {
        var isMissingNecessaryProperties = ['code', 'classification'].some(function (prop) {
            return !code[prop];
        });

        if (!code || isMissingNecessaryProperties) {
            return '';
        }

        var classificationValue = _.get(code, 'classification.value', code.classification);
        return '' + classificationValue;
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/guidance/common/util/IndustryCodeUtil.js
// module id = 965
// module chunks = 0